export const URLS = {
    gimaUsers: process.env.REACT_APP_GIMA_USERS_API,
    gimaAPI: process.env.REACT_APP_GIMA_API,
    mediaAPI: process.env.REACT_APP_MEDIA_API,
    mediaSystem: "cms",
    baseURL: process.env.REACT_APP_BASE_URL,
    dsp_masterURL: process.env.REACT_APP_DSP_MASTER_DEMO_API,
    mediaURL: process.env.REACT_APP_MEDIA_URL,
    clientAppDomain: process.env.REACT_APP_CLIENT_APP_DOMAIN,
    clientPreviewDomain: process.env.REACT_APP_CLIENT_PRIVIEW_DOMAIN,
    footerContent: "/siteInfo/getAll",
    mediaUpload: "/media/upload",
    getAllCountries: "/country/all",
    getSingleSiteDetails: "/site/",
    getSingleSiteCountryDetails: "/site-country/",
    getSingleSiteCountryLangDetails: "/site-country-language/",
    getSingleSitePageDetails: "/site-page/",
    getAllLanguages: "/language/all",
    getAllSites: "/site/all",
    createSite: "/site/create",
    updateSite: "/site/update/",
    deleteSite: "/site/delete/",
    getAllSitesCountries: "/site-country/site/",
    getAllSiteStyles: "/styles/site/",
    editSiteStyles: "/styles/update/",
    createSiteStyles: "/styles/create",
    createCountrySite: "/site-country/create",
    updateCountrySite: "/site-country/update/",
    deleteSiteStyle: "/styles/delete/",
    getAllSiteJS: "/js/site/",
    editSiteJS: "/js/update/",
    createSiteJS: "/js/create",
    deleteSiteJS: "/js/delete/",
    deleteSitesCountry: "/site-country/delete/",
    getAllSiteCountryLang: "/site-country-language/site-country/",
    createSiteCountryLang: "/site-country-language/create",
    deleteSiteCountryLang: "/site-country-language/delete/",
    getAllMenusBySiteCountry: "/site-country-menu/site-country/",
    createMenuBySiteCountry: "/site-country-menu/create",
    updateMenuBySiteCountry: "/site-country-menu/update/",
    getAllFooterMenuBySiteCountry: "/site-country-footer/site-country/",
    createFooterMenuBySiteCountry: "/site-country-footer/create",
    updateFooterMenuItem: "/site-country-footer/update/",
    getAllLanguagePages: "/site-page/site-country-language/",
    copyPage: "/site-page/copy/",
    createLanguagePage: "/site-page/create",
    editLanguagePage: "/site-page/update/",
    deleteLanguagePage: "/site-page/delete/",
    getAllPageContentByPageId: "/site-page-content/site-page/",
    createPageContentByPageId: "/site-page-content/create",
    updatePageContentByPageId: "/site-page-content/update/",
    updatePageContentOrder: "/site-page-content/updateOrder",
    deletePageContentByPageId: "/site-page-content/delete/",
    getAllThemes: "/theme/all",
    getAllTemplates: "/template/all",
    createTemplate: "/template/create",
    deleteTemplate: "/template/delete/",
    getOverAllMenus: "/site-country-menu/all",
    getOverAllFooterMenus: "/site-country-footer/all",
    getOverAllPages: "/site-page/all",
    getGlobalPagesBySiteID: "/site-page/site-id/",
    uploadedFile: "/uploadfile/list",
    getJSONAPI: "/setting/GetJsonByModule",
    getDestinationGuidList: "/destination-guide/all",
    getDestinationGuideVersions: "/destination-guide/version/",
    createDestinationGuidList: "/destination-guide/create",
    getDestinationGuidDetail: "/destination-guide/destination-guide-id",
    editDestinationGuidDetail: "/destination-guide/update",
    deleteDestinationGuid: "/destination-guide/delete",
    deleteGuideVersion: "/destination-guide/version/delete",
    // VIDEO GUIDES
    getVideoGuidList: "/video-guides/all",
    getVideoGuideVersions: "/video-guides/version/",
    createVideoGuidList: "/video-guides/create",
    getVideoGuidDetail: "/video-guides/video-guide-id",
    editVideoGuidDetail: "/video-guides/update",
    deleteVideoGuide: "/video-guides/delete",
    deleteVideoGuideVersion: "/video-guides/version/delete",

    getDestinationGuideSettings: "/destination-media",
    saveDestinationGuideSettings: "/destination-media/save",

    // VIDEO GUIDE SETTINGS
    getVideoGuideSettings: "/videoguide-settings",
    saveVideoGuideSettings: "/videoguide-settings/save"
}